import React, { useState, useRef } from 'react'
import {
  Card,
  Button,
  Row,
  Col,
  Form,
  Avatar,
  Collapse,
  Tag,
  message,
  Tooltip
} from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import RetrieveSale from './RetrieveSale'
import MoreActions from './MoreActions'
import {
  fetchCurrentSalesOrder,
  isEmptyObject,
  parkSale
} from '../../appRedux/actions/GlobalMethods'
import {
  loadCustomerSearchData,
  loadIsShowSellAttribute,
  loadSellAttribTabs,
  loadSellAttribTabs_type,
  loadSellAttributeLoading,
  loadSellAttributes,
  loadSellSelectedAttributes
} from '../../appRedux/actions/Sell'
import CustomScrollbars from '../../util/CustomScrollbars'
import { SellProductJsonBuilder } from '../../appRedux/actions/SellScreenMethods'
import SearchCustomer from '../../components/SearchCustomer'
import ProductList from './ProductList'
import CartDetails from './CartDetails'
import LockOutlined from '@ant-design/icons/lib/icons/LockOutlined'
import CartActionBar from './CartActionBar'
import {
  loadCustomerObj,
  loadSalesOrderStatuses,
  loadIsMainLoading,
  loadParkedSaleModalvisible
} from '../../appRedux/actions/MainSale'
import {
  getDecryptID,
  clusterCalculations
} from '../../appRedux/actions/GlobalMethods'
import { loadSaleHistoryCustomerShow } from '../../appRedux/actions/Sell'
import CustomerModal from '../../routes/Sell/SalesHistory/CustomerModal'
import { HistoryOutlined } from '@ant-design/icons'
import SellAttributeSelect from './SellAttributeSelect'
import { Scrollbars } from 'react-custom-scrollbars'
import { loadSaleAttribData, notAllowMsgCheck } from '../../appRedux/actions'
import ShowSaleDataModal from './ShowSaleDataModal'
import ds from '../../Services/DataServices'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import { SELL_ATTRIB_ACCORDION } from '../../constants/ThemeSetting'
import ShowIconSellGroup from '../../routes/Sell/Settings/ShowIconSellGroup'
import SellAttributeSelectTabs from './SellAttributeSelectTabs'
import { ATTRIB_MODAL_TYPES } from '../../constants/MobAppConstants'
import { GetIndexDBDataByTableName } from '../../appRedux/actions/IndexDBActions'
import { INDEX_DB_NAME, INDEX_DB_TABLES } from '../../constants/IndexDBData'

const { Panel } = Collapse

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const customPanelStyle = {
  background: 'rgb(226 225 225)',
  borderRadius: 4,
  marginBottom: 8,
  border: 0,
  overflow: 'hidden',
  fontWeight: 500,
  textAlign: 'left'
}

const RightPanel = props => {
  const {
    discountPerm,
    getStoreCreditPerm,
    returnStoreCredit,
    allowMakeSales,
    availableUsers
  } = props
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  let customScrollRef = React.useRef(null)

  const ButtonGroup = Button.Group
  const getCurrData = props.getCurrData
    ? props.getCurrData
    : {
        currencyCode: '',
        currencyName: '',
        currencySymbol: ''
      }
  const [getModalCusID, setModalCusID] = useState('')
  const [attribTitle, setAttribTitle] = useState('')
  const [getIsSpinning, setIsSpinning] = useState(true)
  const [showSale, setShowSale] = useState(false)
  const getCustomerObj = useSelector(({ MainSale }) => MainSale.getCustomerObj)
  const getSelectedReg = useSelector(({ MainSale }) => MainSale.getSelectedReg)
  const getStoredBooks = useSelector(({ Sell }) => Sell.salePriceBooks)
  const getStoredPromos = useSelector(({ Sell }) => Sell.salePromotions)

  const getConfigSellAttribute = useSelector(
    ({ commonConfigs }) => commonConfigs.getConfigSellAttribute
  )
  const getIsSalePaymentProcessStart = useSelector(
    ({ MainSale }) => MainSale.getIsSalePaymentProcessStart
  )
  const getReduxSaleProductJsonData = useSelector(
    ({ Sell }) => Sell.saleProductJsonData
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const getBasicIsPercent = useSelector(
    ({ MainSale }) => MainSale.getBasicIsPercent
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getSaleOrderJson = useSelector(
    ({ MainSale }) => MainSale.getSaleOrderJson
  )
  const getCustomerSearchData = useSelector(
    ({ Sell }) => Sell.customerSearchData
  )
  const getIsLoyaltyEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsLoyaltyEnabled
  )
  const getDefaultLoyaltyAmount = useSelector(
    ({ MainSale }) => MainSale.getDefaultLoyaltyAmount
  )
  const getSelectedOutlet = useSelector(
    ({ commonConfigs }) => commonConfigs.getSelectedOutlet
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getCurrentSalesOrderStatusID = useSelector(
    ({ MainSale }) => MainSale.getCurrentSalesOrderStatusID
  )
  const getSalesOrderStatuses = useSelector(
    ({ MainSale }) => MainSale.getSalesOrderStatuses
  )
  const getSalePayments = useSelector(
    ({ MainSale }) => MainSale.getSalePayments
  )
  const sellAttributesGroups = useSelector(
    ({ Sell }) => Sell.sellAttributesGroups
  )
  const getReduxSalePaymentData = useSelector(
    ({ Sell }) => Sell.salePaymentData
  )
  const sellSelAttributes = useSelector(({ Sell }) => Sell.sellSelAttributes)
  const formDiscPer = useSelector(({ MainSale }) => MainSale.formDiscPer)
  const formDiscCurr = useSelector(({ MainSale }) => MainSale.formDiscCurr)
  const formSellNote = useSelector(({ MainSale }) => MainSale.formSellNote)
  const getRefundKeys = useSelector(({ MainSale }) => MainSale.getRefundKeys)
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const getDeletedProds = useSelector(({ MainSale }) => MainSale.deletedProds)
  const sellActionLog = useSelector(({ Sell }) => Sell.sellActionLog)
  const getSavings = useSelector(({ MainSale }) => MainSale.getTotalSaving)

  React.useEffect(() => {
    let mounted = true
    if (
      mounted &&
      getReduxSaleProductJsonData &&
      getReduxSaleProductJsonData.length > 0
    ) {
      if (customScrollRef && customScrollRef.scrollToBottom != undefined) {
        customScrollRef.scrollToBottom()
      }
    }
  }, [getReduxSaleProductJsonData])

  React.useEffect(() => {
    let mounted = true
    if (mounted && isEmptyObject(getCustomerSearchData)) {
      form.resetFields()
    }
  }, [getCustomerSearchData])

  const handleParKedSaleModalVisibility = isVisible => {
    // setConfirmLoading(false);
    // setParkedSaleModalvisible(isVisible);
    dispatch(loadParkedSaleModalvisible(isVisible))
  }

  const onFinish = values => {
    // setIsMainLoading(true);
    dispatch(loadIsMainLoading(true))
  }

  const onFinishFailed = errorInfo => {}

  const RemoveCustomerSaleStatuses = () => {
    const tempsaleStatuses =
      getSalesOrderStatuses &&
      getSalesOrderStatuses.map(e => {
        return {
          SalesOrderStatuID: e.SalesOrderStatuID,
          StatusName: e.StatusName,
          IsActive: e.IsActive,
          IsDisabled: true
        }
      })
    dispatch(loadSalesOrderStatuses(tempsaleStatuses))
  }

  const handleCustomerDelete = () => {
    dispatch(loadCustomerObj({}))
    RemoveCustomerSaleStatuses()
    dispatch(loadCustomerSearchData({}))
    let items = getReduxSaleProductJsonData
    if (items && items.length > 0) {
      let fddlerPrds = getReduxSaleProductJsonData
      //NOTE: there is need to call again the prod builder method for working properly of removing the customer (entire sale off scenario where ref work for the whole sale)
      items.map(item => {
        const productsClone = SellProductJsonBuilder(
          item,
          undefined,
          '',
          {},
          getReduxSaleProductJsonData,
          getStoredBooks,
          getIsLoyaltyEnabled,
          getDefaultLoyaltyAmount,
          getIsTaxExclusive,
          getStoredPromos,
          getDefaultDecimalPlaces,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getIsRefundSale,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          false,
          getSavings,
          'RightPanel',
          false,
          sellSelAttributes
        )
        if (productsClone && !isEmptyObject(productsClone)) {
          if (
            productsClone.key &&
            fddlerPrds.filter(a => a.key === productsClone.key)[0]
          ) {
            let index = fddlerPrds.indexOf(
              fddlerPrds.filter(a => a.key == productsClone.key)[0]
            )
            fddlerPrds[index] = productsClone
          } else {
            fddlerPrds = fddlerPrds.concat(productsClone)
          }
        }
      })
      clusterCalculations(
        fddlerPrds,
        getSelectedOutlet,
        getSelectedReg,
        getBasicIsPercent,
        getCustomerSearchData,
        getIsRefundSale,
        getDefaultDecimalPlaces,
        getCurrentSalesOrderData,
        getCurrentSalesOrderStatusID,
        formDiscCurr,
        formDiscPer,
        formSellNote,
        getRefundKeys,
        getSalePayments,
        dispatch,
        getStoredPromos,
        getIsTaxExclusive,
        false,
        getSavings,
        sellSelAttributes
      )
    }
  }

  function cancelAttribTag (id) {
    let attribs = []
    if (typeof id === 'string') {
      attribs = sellSelAttributes.filter(
        a => getDecryptID(a.sellAttribID) != getDecryptID(id)
      )
    } else {
      attribs = sellSelAttributes.filter(a => a.sellAttribID != id)
    }
    dispatch(
      loadSellSelectedAttributes(attribs && attribs.length > 0 ? attribs : [])
    )
  }

  function evenOrOdd (num) {
    //for string length take string
    if (num % 2 == 0) {
      //and replace numm with string.length here
      return 'even'
    } else {
      return 'odd'
    }
  }

  function changeShowModal () {
    setShowSale(false)
    setAttribTitle('')
    dispatch(loadSaleAttribData([]))
  }

  async function getDetailService (body, name) {
    setIsSpinning(true)
    const getSaleHistoryByID = ds.getSaleHistoryByIdService(
      body,
      BEHAVIOUR_TYPE.GET
    )
    await getSaleHistoryByID
      .then(res => {
        setIsSpinning(false)
        if (res && res.length > 0) {
          //marking to identify that the prods coming first time from backend
          // const sale = res[0]
          // if (sale.products && sale.products.length > 0) {
          //   sale.products.map(a => (a.firstTime = true))
          // }
          dispatch(loadSaleAttribData(res))
        } else {
          changeShowModal()
          message.info(`No Parked Sales ${name ? `on ${name}` : ''}`, 5)
        }
      })
      .catch(e => {
        setShowSale(false)
        dispatch(loadSaleAttribData([]))
        notAllowMsgCheck(e)
        setIsSpinning(false)
      })
  }

  function onAttribClick (w, e) {
    if (isOnline) {
      w.stopPropagation()
      if (getDecryptID(e.attributeID)) {
        setAttribTitle(e.attributeName)
        setShowSale(true)
        const body = {
          OutletID: getSelectedOutlet ? getSelectedOutlet : '',
          // SalesOrderID: `${id}&&_9efa-1ea9-4faf-88ed-a48e65b46643`,
          SalesOrderStatusID: '',
          CustomerID: '',
          UserID: '',
          IsRetrieve: true,
          AttributeID: getDecryptID(e.attributeID)
        }
        getDetailService(body, e.attributeName)
      } else {
        message.warn('Connection failed, kindly refresh or check connections')
      }
    }
  }

  const SelectedAttribTags = props => {
    // const { data } = props
    return (
      sellSelAttributes &&
      sellSelAttributes.length > 0 && (
        <div className='reservation-tags div-flow'>
          {sellSelAttributes.map((as, io) => {
            const isEvenOrOdd = evenOrOdd(io)
            return (
              <Tag
                style={{ cursor: 'pointer' }}
                color={isEvenOrOdd == 'even' ? '#66a54b' : '#87d068'}
                icon={
                  <CloseCircleOutlined
                    onClick={w => {
                      w.stopPropagation()
                      cancelAttribTag(as.sellAttribID ? as.sellAttribID : '')
                    }}
                    style={{ display: 'inline-grid' }}
                  />
                }
                key={io}
                onClick={w => onAttribClick(w, as)}
              >
                {as.groupName ? `${as.groupName}: ` : ''}
                {as.attributeName ? `${as.attributeName}` : ''}
              </Tag>
            )
          })}
        </div>
      )
    )
  }

  function onParkedClick (e) {
    if (
      getConfigSellAttribute &&
      sellAttributesGroups &&
      sellAttributesGroups.length > 0
    ) {
      if (
        getSaleOrderJson &&
        getCurrentSalesOrderData &&
        !isEmptyObject(getSaleOrderJson) &&
        !isEmptyObject(getCurrentSalesOrderData) &&
        getCurrentSalesOrderData.attribProps &&
        getCurrentSalesOrderData.attribProps.length > 0
      ) {
        handleClickParkedSale(getCurrentSalesOrderData.attribProps)
      } else {
        dispatch(loadSellAttributeLoading(true))
        dispatch(
          loadSellAttributes(
            {
              GroupID: sellAttributesGroups[0].groupID
                ? sellAttributesGroups[0].groupID
                : '',
              OutletID: getSelectedOutlet
            },
            isOnline
          )
        )
        dispatch(loadSellAttribTabs(true))
        dispatch(loadSellAttribTabs_type(ATTRIB_MODAL_TYPES.PARK_SALE))
      }
    } else {
      handleParKedSaleModalVisibility(true)
    }
  }

  const handleClickParkedSale = postData1 => {
    if (isOnline && getSaleOrderJson.indexKey) {
      const checkParked = GetIndexDBDataByTableName(
        INDEX_DB_NAME,
        INDEX_DB_TABLES.SALES
      )
      checkParked
        .then(async e => {
          const saleExist = e.filter(
            q =>
              q.indexKey == getSaleOrderJson.indexKey &&
              q.isOffline &&
              q.isParked
          )
          if (saleExist && saleExist.length > 0) {
            parkSaleFn(postData1, false)
          } else parkSaleFn(postData1, isOnline)
        })
        .catch(e => {
          parkSaleFn(postData1, isOnline)
          // console.log('INDEX_DB_ERROR -> forceUpdateIndexSales -->', e)
        })
    } else {
      parkSaleFn(postData1, isOnline)
    }
  }

  function parkSaleFn (postData1, pretendOnline) {
    parkSale(
      getSaleOrderJson,
      getSalesOrderStatuses,
      getCurrentSalesOrderData,
      {},
      getIsRefundSale,
      dispatch,
      getReduxSalePaymentData,
      postData1, // sellSelAttributes,
      !getIsSalePaymentProcessStart ? sellActionLog : [],
      getDeletedProds ? getDeletedProds : [],
      pretendOnline
    )
  }

  return (
    <>
      <ShowSaleDataModal
        getIsSpinning={getIsSpinning}
        showSale={showSale}
        changeShowModal={changeShowModal}
        title={attribTitle}
      />
      <SellAttributeSelectTabs currency={getCurrData} out={getSelectedOutlet} />
      {/* <SellAttributeSelect currency={getCurrData} /> */}
      {allowMakeSales && (
        <>
          <ButtonGroup className='grp-btn-div'>
            <RetrieveSale />
            <Button
              className=''
              onClick={ee => {
                onParkedClick(getCurrentSalesOrderStatusID, ee)
              }}
              disabled={
                isEmptyObject(getSaleOrderJson) ||
                // getIsSalePaymentProcessStart == true ||
                getDecryptID(getCurrentSalesOrderStatusID) ==
                  getDecryptID(fetchCurrentSalesOrder('LayBy')) ||
                getDecryptID(getCurrentSalesOrderStatusID) ==
                  getDecryptID(fetchCurrentSalesOrder('On Account')) ||
                getDecryptID(getCurrentSalesOrderStatusID) ==
                  getDecryptID(
                    fetchCurrentSalesOrder('Delivery, unfulfilled')
                  ) ||
                getDecryptID(getCurrentSalesOrderStatusID) ==
                  getDecryptID(fetchCurrentSalesOrder('PickUp, unfulfilled'))
                  ? true
                  : false
              }
              icon={<HistoryOutlined className='dk-btn-icon-align' />}
            >
              <IntlMessages id='sell.sell.park' />
              <span className='dk-text-hide-on-mobile'>
                <IntlMessages id='sell.sell.sale' />
              </span>
            </Button>
            <MoreActions
              isDisabled={
                isEmptyObject(getSaleOrderJson) ||
                getIsSalePaymentProcessStart == true
                  ? true
                  : false
              }
            />
          </ButtonGroup>
          {!SELL_ATTRIB_ACCORDION && <SelectedAttribTags />}
        </>
      )}
      <Form
        {...formItemLayout}
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        scrollToFirstError
        id='SellForm'
        name='SellForm'
        className='input-grp Cart-div div-flow'
      >
        {getCustomerObj && getCustomerObj.customerCode ? (
          <>
            <Card
              className='sell-customer-account-card'
              title={
                <div className='gx-module-list-icon'>
                  <Row gutter={12}>
                    <Col>
                      <div className='gx'>
                        <Avatar
                          style={{ fontWeight: 'bold' }}
                          className={`gx-avatar gx-bg-${
                            true == 'even' ? 'green' : 'blue'
                          } gx-size-46 mr-10`}
                        >
                          {getCustomerObj.letterName
                            ? getCustomerObj.letterName
                            : '00'}
                        </Avatar>
                      </div>
                    </Col>

                    <Col>
                      <div className='gx-module-list-content'>
                        <div className='gx-mail-user-des'>
                          <span
                            onClick={() => {
                              if (isOnline) {
                                let randomNbr = Math.floor(
                                  Math.random() * (999 - 100 + 1) + 100
                                )
                                let idCus =
                                  getCustomerObj.customerSId +
                                  randomNbr.toString()
                                setModalCusID(idCus)
                                dispatch(loadSaleHistoryCustomerShow(true))
                              }
                            }}
                            className='gx-sender-name'
                          >
                            <p className='custom-customer-name'>
                              {getCustomerObj.customerFirstName
                                ? getCustomerObj.customerFirstName
                                : '-Name-'}
                              {getCustomerObj.customerLastName
                                ? getCustomerObj.customerLastName
                                : ' '}
                            </p>
                          </span>

                          <span className='gx-toolbar-separator'>&nbsp;</span>

                          <span className='vd-flag sm:hidden'>
                            {getCustomerObj.groupName
                              ? getCustomerObj.groupName
                              : 'All Customers'}
                          </span>
                        </div>
                        <div className='gx-message'>
                          <p className='gx-text-truncate'>
                            {getCustomerObj.customerCode
                              ? getCustomerObj.customerCode
                              : '000-ABC'}
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              }
              extra={
                getDecryptID(getCurrentSalesOrderStatusID) !== '2' &&
                getDecryptID(getCurrentSalesOrderStatusID) !== '1' &&
                getDecryptID(getCurrentSalesOrderStatusID) !== '4' &&
                getDecryptID(getCurrentSalesOrderStatusID) !== '5' ? (
                  <div className='del-btn-div'>
                    <a
                      onClick={() => handleCustomerDelete()}
                      className='trash-icon-btn'
                    >
                      {' '}
                      <i className='icon icon-trash' />{' '}
                    </a>
                  </div>
                ) : (
                  <LockOutlined />
                )
              }
            ></Card>
          </>
        ) : (
          <SearchCustomer screen='SellScreen' />
        )}

        {/* <Scrollbars
          autoHide
          ref={x => {
            customScrollRef = x
          }}
          className='gx-module-content-scroll cart-area-content POS-cart-Products'
        >
          <ProductList discountPerm={discountPerm} />
        <CartDetails getCurrData={getCurrData} discountPerm={discountPerm} />
        </Scrollbars> */}

        <div className='Cart-Container-div div-flow'>
          <ProductList discountPerm={discountPerm} availableUsers={availableUsers} />
          <div className='cart-price-pay-div'>
            <CartDetails
              getCurrData={getCurrData}
              discountPerm={discountPerm}
            />
            <CartActionBar
              getCurrData={getCurrData}
              allowMakeSales={allowMakeSales}
            />
          </div>
        </div>
      </Form>
      <CustomerModal
        id={getModalCusID}
        currShort={getCurrData.currencyCode ? getCurrData.currencyCode : ''}
        getIsIssueStoreCredit={getStoreCreditPerm}
        returnStoreCredit={returnStoreCredit}
      />
    </>
  )
}

export default RightPanel
